import { stateTypes, getterTypes } from './common.moduletypes';

import {} from '../models/common.models';

import actions from './common.moduleactions';
import mutations from './common.modulemutations';

import CommonApi from '../services/common.api';

export default {
  // see https://vuex.vuejs.org/guide/modules.html#namespacing
  namespaced: true,

  state: {
    [stateTypes.schedule]: null,
    [stateTypes.schedules]: [],
    [stateTypes.userProfile]: {
      dateFormat: 'dd/MM/yyyy',
      estimatedProduction: 1,
      metricData: true,
      acceptedToS: 0
    },
    [stateTypes.regions]: {
      regions: [],
      statics: {
        tos: {
          ver: 0
        }
      }
    },
    [stateTypes.oneNews]: {},
    [stateTypes.news]: [],
    [stateTypes.recommendations]: [],
    [stateTypes.wireOems]: [],
    [stateTypes.logData]: {
      hasMoreEntries: false,
      data: [],
      lastPageLoaded: 0
    },
    [stateTypes.filterLogData]: {
      units: []
    },
    [stateTypes.notificationSettings]: []
  },
  getters: {
    /**
     * here we setup commonApi _once_, it's cached through dependency chain
     * and available through getters.CommonApi for actions
     */
    [getterTypes.commonApi]: () => {
      return new CommonApi();
    },

    [getterTypes.getSchedule]: state => {
      return state[stateTypes.schedule];
    },

    [getterTypes.getSchedules]: state => {
      return state[stateTypes.schedules];
    },

    [getterTypes.getProfile]: state => {
      return state[stateTypes.userProfile];
    },

    [getterTypes.getProfileDateFormat]: state => {
      return state[stateTypes.userProfile].dateFormat;
    },

    [getterTypes.getProfileEstimatedProduction]: state => {
      return state[stateTypes.userProfile].estimatedProduction;
    },

    [getterTypes.getProfileMetricData]: state => {
      return state[stateTypes.userProfile].metricData;
    },

    [getterTypes.getRegions]: state => {
      return state[stateTypes.regions].regions;
    },

    [getterTypes.getOneNews]: state => {
      return state[stateTypes.oneNews];
    },

    [getterTypes.getAllNews]: state => {
      return state[stateTypes.news];
    },
    [getterTypes.getRecommendations]: state => {
      return state[stateTypes.recommendations];
    },
    [getterTypes.getAcceptedTos]: state => {
      return state[stateTypes.userProfile].acceptedToS;
    },
    [getterTypes.getLastTosVersion]: state => {
      return state[stateTypes.regions].statics.tos.ver;
    },
    [getterTypes.getWireOems]: state => {
      return state[stateTypes.wireOems];
    },
    [getterTypes.getLogData]: state => {
      return state[stateTypes.logData];
    },
    [getterTypes.getLogFilterData]: state => {
      return state[stateTypes.filterLogData];
    },
    [getterTypes.getNotificationSettings]: state => {
      return state[stateTypes.notificationSettings];
    }
  },

  mutations: mutations,

  actions: actions
};
